/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useRef, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "@mui/material/Table";
import DataTable from "../../examples/Tables/DataTable";
import data from "../dashboard/components/Projects/data";
import useApi from "../../components/Utils/api";
import MDInput from "../../components/MDInput";
import toast from "react-hot-toast";
import subDays from "date-fns/subDays";
import startOfMonth from "date-fns/startOfMonth";
import addMonths from "date-fns/addMonths";
import endOfMonth from "date-fns/endOfMonth";
import { useNavigate } from "react-router-dom";
import Papa from 'papaparse';
import PermissionControl from "../../components/Utils/PermissionControl";

function MerchantGroups() {
  const { merchantGroupTablecolumns } = data();
  const [merchants, setMerchants] = useState([]);
  const navigate = useNavigate();
  const api = useApi();
  const getMerchantGroups = () => {
    api.get("admin/browseMerchantGroup")
      .then((response) => {
        if(response.data.statusCodeValue === 200) {
          setMerchants(response.data.body);
        } else {
          toast.error(response.data.error);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        console.log(error.response.data);
      })
  }
  const generateCSV = () => {
    if (merchants.length === 0) {
      return '';
    }

    const headers = merchantGroupTablecolumns.map(column => column.Header);

    const merchantsWithUppercaseColumns = merchants.map(item => {
      return merchantGroupTablecolumns.map(column => {
        const accessor = column.accessor;
        const value = typeof accessor === 'function' ? accessor(item) : item[accessor];
        return value;
      });
    });

    const csvData = [headers, ...merchantsWithUppercaseColumns];

    const csv = Papa.unparse(csvData, {
      quotes: true,
    });

    return csv;
  };

  const handleDownloadCSV = () => {
    if (merchants.length === 0) {
      toast.error("No records found to download.");
      return;
    }

    const csvData = generateCSV();

    const currentDate = new Date().toISOString().slice(0, 10);
    const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
    const dateTimeString = `${currentDate}_${currentTime}`;

    const fileName = `MerchantGroups_${dateTimeString}.csv`;

    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  useEffect(() => {
    getMerchantGroups();
  },[]);

  const rowHandler = (row, pageRow)  => {
    // console.log("triggered", pageRow)
    navigate("/merchant-group/single", {
      state: {
        referenceCompany: pageRow.original,
        merchantGroups: merchants
      }
    })
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <PermissionControl permission={{ restrict: true, module: "MerchantGroup", subModule: "Create" }}>
              <MDButton color="info" size="medium" style={{ marginLeft: 'auto', display: 'block' }} variant="contained" onClick={() => navigate("/merchant-group/single", { state: { merchantGroups: merchants }  })}>New</MDButton>
            </PermissionControl>
          </Grid>
          <Grid item xs={12} lg={12}>
          <MDButton variant="gradient" onClick={handleDownloadCSV} color="info" style={{marginRight: "24px", marginBottom: "12px"}}>
                  Export
              </MDButton>
            <DataTable
              table={{ columns : merchantGroupTablecolumns, rows : merchants }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              canSearch={true}
              onRowClicked={rowHandler}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MerchantGroups;
